'use client';

import { useDraggable } from '@dnd-kit/core';
import { CSS } from '@dnd-kit/utilities';
import { sortableItemStyle, draggingItemStyle } from '@/_constants/dnd-kit';

export const useDraggableItem = (
  id: string | number,
  disabled?: boolean,
  customStyle?: React.CSSProperties,
) => {
  const { attributes, listeners, setNodeRef, transform, isDragging } =
    useDraggable({
      id,
      disabled,
    });

  const baseStyle = isDragging ? draggingItemStyle : sortableItemStyle;

  const style = {
    transform: CSS.Translate.toString(transform),
    ...baseStyle,
    ...customStyle,
  };

  return {
    attributes,
    listeners,
    setNodeRef,
    style,
    isDragging,
  };
};
